// extracted by mini-css-extract-plugin
export var linkText = "_om-0";